import { render, staticRenderFns } from "./TAddAdministrator.vue?vue&type=template&id=7ae048a2&"
import script from "./TAddAdministrator.vue?vue&type=script&lang=js&"
export * from "./TAddAdministrator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports